import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SubtitlesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"subtitles"}/>
}
